import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AuthenticationsState, featureKey, State } from './combiner';

export const selectAuthenticationsState = createFeatureSelector<State, AuthenticationsState>(featureKey);

export const selectVertiLoginState = createSelector(
  selectAuthenticationsState,
  (state: AuthenticationsState) => state.vertiLogin
);
export const selectLoginState = createSelector(
  selectAuthenticationsState,
  (state: AuthenticationsState) => state.login
);
export const selectRefreshLoginState = createSelector(
  selectAuthenticationsState,
  (state: AuthenticationsState) => state.refreshLogin
);
